'use client';

import { IHeaderProps } from '@/globals/Header/type';
import MHeaderHamburgerMenu from '@/globals/Header/components/mobile/MHeaderHamburgerMenu';
import { MediaComponent } from '@/components/Media';
import { Media } from '@/payload-types';
import React, { Suspense, useRef } from 'react';
import MHeaderSearch from '@/globals/Header/components/mobile/MHeaderSearch';
import Link from 'next/link';

export default function HeaderMobile(props: IHeaderProps) {
  const { header } = props;
  const logo = header?.firstRow?.logo;

  const headerRef = useRef<HTMLDivElement>(null);

  return (
    <div ref={headerRef} className="container relative md:hidden h-14 flex items-center justify-between">
      <Suspense fallback={null}>
        <MHeaderHamburgerMenu {...props} />
      </Suspense>
      {logo && (
        <Link href="/">
          <MediaComponent
            resource={{ ...(logo as Media), height: 32, width: 150 }}
            imgClassName="h-8 object-contain"
          />
        </Link>
      )}
      <MHeaderSearch />
    </div>
  );
}
